import { ChevronFlip } from '@subaio/components'

import { Container } from './Container'
import { Spinner } from './Spinner'

type Props = {
	isMenuOpen: boolean
	isLoading: boolean
	hasError: boolean
}

export const MenuIndicator = ({ isMenuOpen, isLoading, hasError }: Props) => (
	<Container isActive={isMenuOpen} hasError={hasError}>
		{isLoading ? <Spinner size={21} /> : <ChevronFlip isActive={!isMenuOpen} style={{ marginBottom: '3px' }} />}
	</Container>
)
